module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.savingOrgDefault),
      expression: "savingOrgDefault"
    }],
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.coaList.length > 0) ? [_c('v-form-table', {
    attrs: {
      "form": _vm.form,
      "list": _vm.sortedCoaList,
      "create": _vm.save,
      "update": _vm.update,
      "destroy": _vm.destroy,
      "translation": "static.organizationSettings.coa",
      "sortable-fields": ['code', 'name'],
      "sort-field": _vm.sortField,
      "sort-direction": _vm.sortDirection,
      "extra-column-header-label": _vm.$t('static.organizationSettings.coa.orgDefault.label')
    },
    on: {
      "sort": _vm.onSort
    },
    scopedSlots: _vm._u([{
      key: "extraColumn",
      fn: function(ref) {
        var item = ref.item;

        return [_c('el-select', {
          staticClass: "full-w",
          attrs: {
            "value": _vm.orgDefaultRoleFor(item),
            "disabled": _vm.savingOrgDefault,
            "size": "small"
          },
          on: {
            "change": function($event) {
              return _vm.onOrgDefaultChange(item, $event)
            }
          }
        }, [_c('el-option', {
          attrs: {
            "label": _vm.$t('static.organizationSettings.coa.orgDefault.none'),
            "value": ""
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('static.organizationSettings.coa.orgDefault.receivables'),
            "value": "receivables"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('static.organizationSettings.coa.orgDefault.income'),
            "value": "income"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('static.organizationSettings.coa.orgDefault.vat'),
            "value": "vat"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "label": _vm.$t('static.organizationSettings.coa.orgDefault.deposit'),
            "value": "deposit"
          }
        })], 1)]
      }
    }], null, false, 14637755)
  })] : [_c('div', [_c('v-message', {
    attrs: {
      "warning": _vm.$t('static.organizationSettings.coa.noCoa')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center"
  }, [_c('el-button', {
    attrs: {
      "loading": !_vm.ready
    },
    on: {
      "click": _vm.createCoa
    }
  }, [_vm._v(_vm._s(_vm.$t('static.organizationSettings.coa.createCoa').toUpperCase()))])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3467fcfa","hasScoped":false}!./src/app/components/chartOfAccounts/chartOfAccounts.html
// module id = 2966
// module chunks = 1